<template>
  <v-row v-if="page_content && report_content" class="ma-0 backgroundWhite reporting">
    <v-col cols="12" class="pa-0">
      <v-row justify="center" class="ma-0 backgroundWhite reporting">
        <v-col cols="2" class="py-0">
          <v-card flat class="mx-auto" color="backgroundLight" max-width="400">
            <v-list dense>
              <v-subheader>REPORTS</v-subheader>
              <v-list-item-group v-model="report_type" color="primary">
                <v-list-item v-for="(type, i) in report_types" :key="i" :value="type.id">
                  <v-list-item-icon>
                    <v-icon :icon="type.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ type.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="8" class="report-border backgroundWhite">
          <component :is="report_components[report_type]" :device_id="deviceId" />
        </v-col>
      </v-row>
    </v-col>
    <DialogVT v-if="isTester" :contained="contained" />
  </v-row>
</template>

<script>
import ScavengerEN50160Report from "../components/ScavengerEN50160Report";
import ScavengerIEC61000Report from "../components/ScavengerIEC61000Report";
import ScavengerCustomizeReport from "../components/ScavengerCustomizeReport";
import ScavengerHarmonicsReport from "../components/ScavengerHarmonicsReport";
import DialogVT from "../components/DialogVT";
import { content } from "../../config/scavenger.js";
import { content as report_content } from "../../config/scavenger_reports.js";
import { content as h2_report_content } from "../../config/scavenger_h2_reports.js";

export default {
  props: ["deviceId"],
  name: "ScavengerAssetReport",
  components: {
    ScavengerEN50160Report,
    ScavengerIEC61000Report,
    ScavengerCustomizeReport,
    ScavengerHarmonicsReport,
    DialogVT,
  },
  data: function () {
    return {
      page_content: null,
      report_content: null,
      contained: true,
      report_components: {},
      report_types: null,
      report_type: null,
    };
  },
  created() {
    this.page_content = content;
    this.report_content =
      this.$store.state.tenant_config.powerdata_type == "h2scan" ? h2_report_content : report_content;
    this.report_types = this.report_content.report_types;
    // Creating a object of report components from the config file.
    // This object will be used to render the report component based on the selected report type.
    // This is done to avoid using v-if in the template.
    this.report_types.map((type) => {
      this.report_components[type.id] = type.id;
    });
  },
  mounted() {
    this.report_type = this.report_types[0].id;
  },
  computed: {
    isTester: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("Tester") != -1 ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.report-border {
  border: 1px solid var(--v-borderDark-base) !important;
  border-radius: 0.5%;
}
</style>
